import React from 'react';
import cx from 'classnames';
import styles from './table.module.scss';
import { ITableCell } from './table.model';

const TableCell = (props: ITableCell) => {
  const { children, className, align = 'left' } = props;

  const classNames = cx(className);

  return (
    <td className={classNames} align={align}>
      <div>{children}</div>
    </td>
  );
};

export default TableCell;

TableCell.displayName = 'Table.Cell';
